import { apiGet, apiPost } from './client.js';

export interface WorkflowStep {
  id: number;
  runId: number;
  externalId: string;
  name: string;
  status: string;
  errorMessage: string | null;
  resumeUrl: string | null;
  attemptCount: number;
  startedAt: string | null;
  completedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface WorkflowRun {
  id: number;
  userId: number;
  type: string;
  status: string;
  triggeredBy: number | null;
  idempotencyKey: string;
  dispatchedAt: string | null;
  startedAt: string | null;
  completedAt: string | null;
  errorMessage: string | null;
  createdAt: string;
  updatedAt: string;
  steps: WorkflowStep[];
}

export async function getUserWorkflowRuns(userId: number): Promise<WorkflowRun[]> {
  const res = await apiGet<{ data: WorkflowRun[] }>(`/admin/users/${userId}/workflows`);
  return res.data;
}

export async function triggerUserWorkflow(
  userId: number
): Promise<{ runId: number; status: string }> {
  const res = await apiPost<{ data: { runId: number; status: string } }>(
    `/admin/users/${userId}/workflows/trigger`
  );
  return res.data;
}

export async function retryWorkflowDispatch(
  runId: number
): Promise<{ runId: number; status: string }> {
  const res = await apiPost<{ data: { runId: number; status: string } }>(
    `/admin/workflows/${runId}/retry-dispatch`
  );
  return res.data;
}

export async function retryWorkflowStep(
  stepId: number
): Promise<{ stepId: number; status: string; attemptCount: number }> {
  const res = await apiPost<{ data: { stepId: number; status: string; attemptCount: number } }>(
    `/admin/workflows/steps/${stepId}/retry`
  );
  return res.data;
}

export async function confirmManualStep(
  stepId: number
): Promise<{ stepId: number; status: string }> {
  const res = await apiPost<{ data: { stepId: number; status: string } }>(
    `/admin/workflows/steps/${stepId}/confirm-manual`
  );
  return res.data;
}
